<template>
  <div class="advanced-row row gx-0 gy-1 align-items-end">
    <div class="col-6 px-0 justify-content-start">
      <div class="d-flex flex-row flex-nowrap align-items-center advanced-input-container">
			<label for="city_name" class="text-start me-0 me-md-3" style="min-width: 40px;">{{ $t('city.name') }}</label>
			<div class="col-7 col-xl-8">
				<div class="input-group flex-fill">
					<input
					type="text"
					class="form-control custom-input py-0 w-100"
					id="city_name"
					autocomplete="off"
					:placeholder="$t('city.placeholder')"
					v-model="searchCity"
					@focus="onInputFocus"
					/>
				</div>
			</div>
      </div>
    </div>

    <div class="col-6 px-0">
      <div class="d-flex flex-row flex-nowrap align-items-center advanced-input-container">
          <label for="countries" class="text-start me-md-3" style="min-width: 50px;">{{ $t('country.name') }}</label>
		<div class="col-7 col-xl-8">
            <Multiselect
			  ref="countryMultiselect"
              v-bind="multiselectSettings"
              v-model="selectedCountry"
			  :placeholder="$t('country.placeholder')"
			  :append-to-body="true"
			  :appendToBody="true"
			  :clear-on-select="false"
			  :preserve-search="true"
              class="multiselect_advanced_country w-100"
			  @open="onMultiselectOpen"
			  @close="onMultiselectClose"
			  @select="onCountrySelect">
              <template #option="optionProps">
                <span
                  class="fi fi-big"
                  :class="'fi-' + optionProps.option.iso.toLowerCase()"
                ></span>
                <span class="ms-2">{{ optionProps.option.name }}</span>
              </template>
            </Multiselect>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import axios from "axios";

const api = axios.create({
		baseURL: "/api/",
		withCredentials: true,
		xsrfCookieName: "csrftoken",
		xsrfHeaderName: "X-CSRFToken"
});

export default {
		components: {
				Multiselect
		},
		data: function () {
				return {
						countries: [],
						selectedCountry: null,
						searchCity: null,
            			isMultiselectOpen: false
				}
		},
		props: {
			advancedVisible: {
				type: Boolean,
				default: true
			}
		},
		created: function () {
				var language = document.getElementById("language").innerText;
				api.get("countries/" + language)
						.then(r => {
								this.countries = r.data.countries;
						})
		},
		computed: {
				multiselectSettings: function () {
						return {
								label: "name",
								trackBy: "iso",
								placeholder: "",
								options: this.countries,
								searchable: true,
								internalSearch: true,
								showLabels: true,
								multiple: false,
								openDirection: "bottom",
								showLabels: false,
								customLabel: this.customLabel,
								limitText: function (count) { return this.$tc("utils.more", count) }.bind(this),
								optionHeight: 60,
						}
				}
		},
		watch: {
			searchCity: function (val) {
				this.$emit("advanced-search", {
					city: val,
					country: this.selectedCountry ? this.selectedCountry.iso : null
				});
			},
			selectedCountry: function (val) {
				this.$emit("advanced-search", {
					city: this.searchCity,
					country: val ? val.iso : null
				});
			},
			advancedVisible(newVal) {
				if (!newVal) {
					this.closeMultiselectDropdown();
				}
			}
		},
		methods: {
			onInputFocus() {
				this.$emit('keep-open');
			},
			onMultiselectOpen() {
                this.isMultiselectOpen = true;
                this.$emit('keep-open');

                this.$nextTick(() => {
                    const dropdown = this.$el.querySelector('.multiselect__content-wrapper');
                    if (!dropdown || dropdown.dataset.teleported === 'true') return;

                    const rect = this.$el.querySelector('.multiselect_advanced_country').getBoundingClientRect();

                    Object.assign(dropdown.style, {
                        position: 'absolute',
                        top: `${rect.bottom + window.scrollY}px`,
                        left: `${rect.left + window.scrollX}px`,
                        zIndex: '10000',
                        width: `${rect.width}px`,
                        minWidth: `${rect.width}px`,
                        backgroundColor: '#F8F1EA',
                        border: '2px solid #2E282A',
                        borderRadius: '7.5px',
                        borderTopLeftRadius: '0px',
                        borderTopRightRadius: '0px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                        marginTop: '0px',
                        fontSize: '0.95rem',
                        fontWeight: '400'
                    });

                    const styleId = 'country-dropdown-styles';
                    if (!document.getElementById(styleId)) {
                        const style = document.createElement('style');
                        style.id = styleId;
                        style.innerHTML = `
                            .multiselect__element--selected,
                            .multiselect__option--highlight {
                                background-color: #e4d1bd !important;
                                color: #1f1f1f !important;
                            }
                        `;
                        document.head.appendChild(style);
                    }

                    dropdown.dataset.teleported = 'true';
                    document.body.appendChild(dropdown);
                });
            },
            closeMultiselectDropdown() {
                if (this.$refs.countryMultiselect) {
                    this.$refs.countryMultiselect.deactivate();
                }
                this.isMultiselectOpen = false;
            },

            onMultiselectClose() {
                this.isMultiselectOpen = false;
            },
			onCountrySelect(selectedOption) {
				this.$emit('keep-open');
			},
			customLabel(option) {
				return option.name;
			}
		},
		beforeDestroy() {
			this.closeMultiselectDropdown();
		}
	}
</script>

<style></style>